import CreatorInstagramPosts from "./CreatorInstagramPosts"
export default CreatorInstagramPosts
